import axios from 'axios';
import errorMessage from 'Store/actions/errorMessage';

import {
  GET_CHANCE_GAMES_LIST_REQUEST,
  GET_CHANCE_GAMES_LIST_SUCCESS,
  GET_CHANCE_GAMES_LIST_FAILURE
} from 'Store/constants';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getChanceGamesList = () => async dispatch => {
  try {
    dispatch({
      type: GET_CHANCE_GAMES_LIST_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/cms/content/game/v2`);

    dispatch({
      type: GET_CHANCE_GAMES_LIST_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_CHANCE_GAMES_LIST_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};
